var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-section"},[_c('div',{ref:"market",staticClass:"about-market"},[_c('b-img',{class:{ showClass: _vm.show},attrs:{"src":require("@/assets/images/about/market.jpg"),"fluid":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }